import { render, staticRenderFns } from "./InlineAlert.vue?vue&type=template&id=1f2bcfa4"
import script from "./InlineAlert.vue?vue&type=script&lang=ts"
export * from "./InlineAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports